import React from 'react';
import { FileInput } from 'shared/containers/portal_layout/HForm';

const FileAttachments = ({ fields }) => (
  <div className="file-attachment-inputs">
    {fields.map((fieldPrefix, index) => (
      <FileInput
        placeholder="select a file"
        key={index}
        multiple
        name={`${fieldPrefix}.document`}
        removable={index > 0}
        remove={() => fields.remove(index)}
      />
    ))}
    <a className="hyperlink" onClick={() => fields.push({})}>
      Add another file
    </a>
  </div>
);

FileAttachments.displayName = 'FileAttachments';

export default FileAttachments;
